// extracted by mini-css-extract-plugin
module.exports = {"description":"bENvXB2dj2dBkwg47Qyo","path":"jBlZn5pqL5PoVp2fGeh5","single":"dePUu96jeBg7lDustlpy"};